import { instance } from "api/apiBase";
import { PaginatedResponse } from "shared/types";
import {
  BaseLandlordSurvey,
  CreateSurveyPayload,
  DetailedLandlordSurvey,
  UpdateLandlordDetailsPayload,
  UpdateSurveyPayload
} from "./types/types";

const BASE = "/portal/v1/premium_rental_history/survey_templates";
const SURVEYS_BASE = "/portal/v1/premium_rental_history/surveys";

export const landlordSurveyApi = {
  /** Resend a premium survey by its token (authenticated portal action) */
  resendSurvey: async (token: string): Promise<void> => {
    await instance.post(`${SURVEYS_BASE}/${token}/resend`);
  },

  /** Update premium survey landlord details by token (resends on email change) */
  updateLandlordDetails: async (
    token: string,
    payload: UpdateLandlordDetailsPayload
  ): Promise<void> => {
    await instance.post(`${SURVEYS_BASE}/${token}/landlord_details`, payload);
  },

  getSurveys: async (): Promise<BaseLandlordSurvey[]> => {
    const { data } =
      await instance.get<PaginatedResponse<BaseLandlordSurvey>>(BASE);
    return data.items;
  },

  getSurveyByIdentifier: async (
    identifier: string
  ): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.get<DetailedLandlordSurvey>(
      `${BASE}/${identifier}`
    );
    return data;
  },

  createSurvey: async (
    payload: CreateSurveyPayload
  ): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.post<DetailedLandlordSurvey>(BASE, payload);
    return data;
  },

  updateSurvey: async (
    identifier: string,
    payload: UpdateSurveyPayload
  ): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.patch<DetailedLandlordSurvey>(
      `${BASE}/${identifier}`,
      payload
    );
    return data;
  },

  duplicateSurvey: async (
    identifier: string
  ): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.post<DetailedLandlordSurvey>(
      `${BASE}/${identifier}/duplicate`
    );
    return data;
  },

  deleteSurvey: async (identifier: string): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.delete<DetailedLandlordSurvey>(
      `${BASE}/${identifier}`
    );
    return data;
  },

  makeDefault: async (identifier: string): Promise<DetailedLandlordSurvey> => {
    const { data } = await instance.patch<DetailedLandlordSurvey>(
      `${BASE}/${identifier}`,
      { is_default: true, dirty_map: ["is_default"] }
    );
    return data;
  }
};
